import { DependencyList, useCallback } from 'react'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../../../../services'

type CancelCallbackProps = {
    domainId?: number
    consumerCancelHandler?(): void | Promise<void>
}

export const useNotificationBuilderViewCancelCallback = (props: CancelCallbackProps, deps: DependencyList = []) => {
    const appService = useService(AppService)

    const { domainId, consumerCancelHandler: onCancel } = props

    const goBack = useCallback(() => {
        appService.routeBack()
    }, [domainId])

    return useCallback(async () => {
        if (onCancel) {
            return onCancel()
        }

        goBack()
    }, [onCancel, goBack, ...deps])
}
